import { getDisplayId } from "./getDisplayId.js";

/**
 * Returns a human-readable display name for a model.
 *
 * If the model has no name, or the name is identical to the node_id (which
 * indicates no custom name has been set), this falls back to the short display
 * ID returned by getDisplayId(model).displayID (for example a short code,
 * enclosure ID, or "Unknown"). Otherwise it returns the model's name.
 *
 * This could use more work, but at least this will be a consistent method for
 * getting a display name
 */
export function getDisplayName(device: {
    node_id?: string;
    name?: string;
    EnclosureID?: string;
    enclosureID?: string;
    verdiId?: string;
}): string {
    if (!device) {
        throw new Error(`Error, cannot get display name from ${device}`);
    }

    const id = device.node_id;

    if (!device.name || id === device.name) {
        return getDisplayId(device).displayID;
    }

    return device.name;
}
